import { render } from "./App.vue?vue&type=template&id=cb6e1156&scoped=true"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=cb6e1156&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb6e1156"],['__file',"src/embedded/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cb6e1156"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cb6e1156', __exports__)) {
    api.reload('cb6e1156', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=cb6e1156&scoped=true", () => {
    api.rerender('cb6e1156', render)
  })

}


export default __exports__